/**
 * Eloqua Form Types
 * NOTE : Do not change the values unless they are instructed by the Eloqua team.
 */
export enum EloquaFormType {
  BEYONDCX = 'beyondcx', // Eloqua Form type used for BeyondCX form.
  REQUEST_A_QUOTE = 'beyondcart', // Eloqua Form type used for Request a Quote form.
}
